export default {
    "available_in_your_tariff": "Сіздің тарифіңізде бар",
    "market": "Нарық",
    "market_of_apps": "Қолданбалар нарығы",
    "most_popular_apps": "Ең танымал қолданбалар",
    "new_items": "Жаңа элементтер",
    "recommended_apps": "Ұсынылатын қолданбалар",
    "setup": "Баптау",
    "submit_an_application": "Өтінім жіберіңіз",
    "your_application_was_submitted_our_manager_will_contact_you_soon": "Сіздің сұранысыңыз жіберілді, менеджеріміз сізбен жақын арада хабарласады.",
}
